<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
          
        <!-- <el-col :span="24" visible=false>
          <el-form-item :label="misc_type_name" prop="misc_type_id">
            <el-input v-model="form_data.misctype" autocomplete="off" disabled></el-input>
          </el-form-item>
        </el-col> -->

        <el-col :span="24">
          <el-form-item label="编码" prop="code">
            <el-input v-model="form_data.code" autocomplete="off" placeholder="请输入" :disabled="this.hasId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="编码名称" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="缩写" prop="abbreviation">
            <el-input v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>


export default {
  name: 'l-place-state-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    misctype: {
      type: [Number],
      default: 0
    }
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中

      //是否显示
      tree_node: [

      ],
      //表单数据
      form_data: {
        code: '',
        name: '',
        abbreviation:''
        
      },
      misc_type_name: '',
      //表单验证规则
      rules: {
        name: [
          { required: true, message: '编码不能为空', trigger: 'change' }
        ],
        type: [
          { required: true, message: '名称不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    
    //获取数据
    getData() {

      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`miscCode_updateData`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          this.misc_type_name= ret.data.misc_type_name;
          // this.tree_node = ret.superior;
        }).finally(() => {
          this.loading = false;
        });

      } else {
        // this.form_data.use_type = this.$props.useType
      }
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (!this.hasId) {//添加
            this.$_invoke('miscCode_save', {
				type_id: this.$props.misctype,
				...this.form_data
				}).then(() => {
              this.$_msg.success('添加成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            this.$_invoke(`miscCode_update`, {
              id: this.$props.id,
              ...this.form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>